import React from "react";
import ReactDOM from "react-dom/client";
import { Chart as ChartJS } from "chart.js";
import App from "./App.js";

ChartJS.defaults.font.family = "Saira";
ChartJS.defaults.font.weight = "normal";
ChartJS.defaults.devicePixelRatio = Math.max(window.devicePixelRatio || 1, 2);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<App />);
